import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import SitesOverview from '@/views/SitesOverview.vue'
import SiteView from '@/views/SiteView.vue'
import AlertsView from '@/views/AlertsView.vue'
// import ProcessingView from '@/views/ProcessingView.vue'
import ProcessingView from '@/views/JobQueueView.vue'
import LoginView from '@/views/LoginView.vue'
import ListView from '@/views/ListView.vue'
import AdvanceListView from '@/views/AdvanceListView.vue'
import NotFoundView from '@/views/NotFound.vue'
import SiteEditView from '@/views/SiteEditView.vue'
import PointCloudView from '@/views/PointCloudView.vue'
import PointCloudApIView from '@/views/PointCloudApIView.vue'
import CoherenceView from '@/views/CoherenceView.vue'
import SiteDashboard from '@/views/SiteDashboard.vue'
import DocsView from '@/views/DocsView.vue'
import { useAuthStore } from '@/stores/auth'
import AdminNotifications from '@/components/AdminNotifications.vue'
import { watch } from 'vue'

const router = createRouter({
  // @ts-ignore
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView,
      meta: { nav: true, icon: 'home', priority: '1' }
    },
    {
      name: 'Get Started',
      path: '/start-guide',
      component: () => import('@/views/StartGuide.vue'),
      meta: { nav: false, icon: 'book-open', priority: '7' }
    },
    {
      path: '/alerts',
      name: 'Alerts',
      component: AlertsView,
      meta: { nav: true, icon: 'alert-triangle', priority: '2', protected: true }
    },
    {
      path: '/sites',
      name: 'Sites',
      component: SitesOverview,
      meta: { nav: true, icon: 'flag', priority: '3', protected: true }
    },
    {
      path: '/processing',
      name: 'Processing',
      component: ProcessingView,
      meta: { nav: true, icon: 'cpu', priority: '4', protected: true }
    },
    // @ts-ignore
    // {
    //   path: '/docs/',
    //   name: 'Docs',
    //   // redirect out of the SPA to the static site (nginx serves the docs)
    //   beforeEnter() {
    //     location.href = '/docs/'
    //   },
    //   // redirect: '/docs/',
    //   meta: { nav: true, icon: 'book-open', priority: '5' }
    // },
    {
      path: '/login',
      name: 'Login',
      component: LoginView,
      // don't auto-include in nav as we need to switch based on auth state
      meta: { nav: false, icon: 'user', priority: '6' }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: LoginView,
      // don't auto-include in nav as we need to switch based on auth state
      meta: { nav: false, icon: 'user', priority: '7' }
    },
    {
      path: '/list',
      name: 'list',
      component: ListView,
      meta: { nav: false, icon: 'heart' }
    },
    {
      path: '/advances',
      name: 'Advances',
      component: AdvanceListView,
      meta: { nav: false }
    },
    {
      path: '/site/:site_id',
      name: 'Site :site_id',
      component: SiteDashboard
    },
    {
      path: '/site/:site_id/dashboard',
      name: 'Site Dashboard :site_id',
      component: SiteDashboard
    },
    {
      path: '/site/:site_id/data',
      name: 'Site Data :site_id',
      component: SiteView
    },
    {
      path: '/site/:site_id/edit',
      name: 'Site Edit :site_id',
      component: SiteEditView
    },
    {
      path: '/site_edit/:site_id',
      name: 'Site Edit',
      component: SiteEditView
    },
    {
      path: '/site/:site_id/time_series',
      name: 'Site Points :site_id',
      component: PointCloudView
    },
    {
      path: '/site/:site_id/psi',
      name: 'Site Points :site_id',
      component: PointCloudApIView
    },
    {
      path: '/site/:site_id/psi/:psi_settings',
      name: 'Site Points :site_id',
      component: PointCloudApIView
    },
    {
      path: '/site/:site_id/coherence',
      name: 'Site Coherence :site_id',
      component: CoherenceView
    },
    {
      path: '/site/:site_id/coherence/:psi_settings',
      name: 'Site Coherence :site_id',
      component: CoherenceView
    },
    {
      path: '/helpers',
      name: 'Helpers',
      component: () => import('@/views/HelpersView.vue'),
    },
    {
      path: '/tools',
      name: 'Tools',
      component: () => import('@/views/ThreeChoices.vue'),
      meta: { nav: false, protected: true }
    },
    // catch all 404
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFoundView,
      meta: { nav: false }
    },
    {
      path: '/site/:siteName/projects',
      name: 'Site Projects',
      component: () => import('@/views/ProjectView.vue'),
      meta: { nav: false, protected: true }
    },
    {
      name: 'GDPR',
      path: '/gdpr',  
      component: () => import('@/views/GDPRView.vue'),
      meta: { nav: false }

    },
    {
      name: 'Site Data Search',
      path: '/site/:site_id/data_search',
      component: () => import('@/views/SiteDataSearchView.vue'),
      meta: { nav: false, protected: true }
    },
    {
      name: 'Processing Configuration',
      path: '/site/:siteName/config',
      component: () => import('@/views/ProjectConfig.vue'),
      meta: { nav: false, protected: true }
    },
    {
      name: 'Active Processing',
      path: '/site/:siteName/active',
      component: () => import('@/views/ActiveProcessingView.vue'),
    },
    {
      path: '/docs-view',
      name: 'Documentation',
      component: DocsView,
      meta: { nav: true, icon: 'book-open', priority: '5' }
    },
    {
      path: '/admin-notifications',
      name: 'Admin Notifications',
      component: AdminNotifications,
      meta: { nav: false, priority: '8', protected: true }
    },
    {
      path: '/schemes-of-access',
      name: 'SchemesOfAccess',
      component: () => import('@/views/SchemesOfAccess.vue'),
    },
  ]
})

//

router.beforeEach(async (to, from, next) => {
  const routeName = String(to.name);
  document.title = `${routeName} - StARRS`;

  // check if the user is authenticated
  const authStore = useAuthStore()

  // Wait for auth store to initialize
  if (!authStore.isInitialized) {
    await new Promise<void>((resolve) => {
      const unwatch = watch(() => authStore.isInitialized, (newValue) => {
        if (newValue) {
          unwatch()
          resolve()
        }
      })
    })
  }

  if (!authStore.isAuthenticated && to.meta.protected) {
    // show the login dialog
    authStore.redirectOnSignIn = to.fullPath
    authStore.loginDialogVisible = true
    return
  }
  next();
});

export default router
